function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingPicture4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-line-drawing--picture4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "250px",
    height: "180px",
    viewBox: "0 0 250 180",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 250 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Cloud_1",
    className: "svg-line-drawing__line",
    d: "M245.8,45.5c-11.8,0-40,0-41.3,0c-4.9,0-5-4.5-4.9-5.5c0.6-5.3,5.9-12.2,13.2-7.4c0.3-16,30-19.8,26.5-1c1.3-0.6,4.6-0.9,6.6,1.5",
    style: {
      strokeDasharray: 118.03948211669922,
      strokeDashoffset: 118.03948211669922
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Horizon_1",
    className: "svg-line-drawing__line",
    x1: 245.8,
    y1: 100.1,
    x2: 5.9,
    y2: 100.1,
    style: {
      strokeDasharray: 239.90000915527344,
      strokeDashoffset: 239.90000915527344
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Outline",
    className: "svg-line-drawing__line",
    d: "M4,179c-1.7,0-3-1.4-3-3V4c0-1.7,1.3-3,3-3h242c1.6,0,3,1.3,3,3v172c0,1.6-1.4,3-3,3H4z",
    style: {
      strokeDasharray: 846.8409423828125,
      strokeDashoffset: 846.8409423828125
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_5",
    className: "svg-line-drawing__white",
    d: "M152.5,174.5c-0.1-9.6-0.3-19.2-1.1-27c-3.9-42.8-29.5-75.4-57.1-72.9c-27.6,2.5-46.8,39.3-42.9,82c0.6,6.2,1.6,12.2,2.8,17.8",
    style: {
      strokeDasharray: 248.44642639160156,
      strokeDashoffset: 248.44642639160156
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Body_1",
    className: "svg-line-drawing__line",
    d: "M152.5,174.5c-0.1-9.6-0.3-19.2-1.1-27c-3.9-42.8-29.5-75.4-57.1-72.9c-27.6,2.5-46.8,39.3-42.9,82c0.6,6.2,1.6,12.2,2.8,17.8",
    style: {
      strokeDasharray: 248.44642639160156,
      strokeDashoffset: 248.44642639160156
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_4",
    className: "svg-line-drawing__white",
    d: "M84.9,22.9C65.3,27.1,52.8,46.4,57,66s23.6,32.1,43.1,27.9c19.6-4.2,32.1-23.6,27.9-43.1S104.4,18.6,84.9,22.9z",
    style: {
      strokeDasharray: 228.09173583984375,
      strokeDashoffset: 228.09173583984375
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Hand_1",
    className: "svg-line-drawing__line",
    cx: 32.8,
    cy: 61.5,
    rx: 8.8,
    ry: 12.7,
    style: {
      strokeDasharray: 67.6653060913086,
      strokeDashoffset: 67.6653060913086
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Head_1",
    className: "svg-line-drawing__line",
    cx: 92.5,
    cy: 58.4,
    r: 35.1,
    style: {
      strokeDasharray: 220.1835174560547,
      strokeDashoffset: 220.1835174560547
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mouth_1",
    className: "svg-line-drawing__line",
    d: "M81.5,75.2c0,0,11.7,9.1,26-1.2",
    style: {
      strokeDasharray: 27.839746475219727,
      strokeDashoffset: 27.839746475219727
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arm_1",
    className: "svg-line-drawing__line",
    d: "M32.8,74.2c0,0,3,16.9,21.6,43.6",
    style: {
      strokeDasharray: 48.922569274902344,
      strokeDashoffset: 48.922569274902344
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Brace_1",
    className: "svg-line-drawing__line",
    d: "M175.8,110.5c0,0,9.1-7.3,18,0.6",
    style: {
      strokeDasharray: 19.612951278686523,
      strokeDashoffset: 19.612951278686523
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tower_1",
    className: "svg-line-drawing__line",
    d: "M184.1,32.1c4,54.2-13,90.5-13,90.5s0,0-11.1,0c19-21.3,22.1-90.5,22.1-90.5l2.7-17.6l2.6,17.6c0,0,3.2,69.2,22.1,90.5c-11.1,0-11.1,0-11.1,0s-17-36.4-13-90.5H184.1z",
    style: {
      strokeDasharray: 432.24853515625,
      strokeDashoffset: 432.24853515625
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "White_3",
    className: "svg-line-drawing__white",
    points: "170.1,104.3 199.8,104.3 197.1,97.2 172.2,97.2 ",
    style: {
      strokeDasharray: 69.6001205444336,
      strokeDashoffset: 69.6001205444336
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "White_2",
    className: "svg-line-drawing__white",
    points: "194.8,77.9 175.1,77.9 176.9,82.7 193.4,82.7 ",
    style: {
      strokeDasharray: 46.326393127441406,
      strokeDashoffset: 46.326393127441406
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Tower_bottom_1",
    className: "svg-line-drawing__line",
    points: "170.1,104.3 199.8,104.3 197.1,97.2 172.2,97.2 ",
    style: {
      strokeDasharray: 69.6001205444336,
      strokeDashoffset: 69.6001205444336
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Tower_middle_1",
    className: "svg-line-drawing__line",
    points: "194.8,77.9 175.1,77.9 176.9,82.7 193.4,82.7 ",
    style: {
      strokeDasharray: 46.326393127441406,
      strokeDashoffset: 46.326393127441406
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_1",
    className: "svg-line-drawing__white",
    d: "M187.9,31.8h-6.3c-0.3,0-0.5-0.2-0.5-0.5v-3.3c0-0.3,0.2-0.5,0.5-0.5h6.3c0.3,0,0.5,0.2,0.5,0.5v3.3C188.4,31.5,188.2,31.8,187.9,31.8z",
    style: {
      strokeDasharray: 22.363540649414062,
      strokeDashoffset: 22.363540649414062
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tower_top_1",
    className: "svg-line-drawing__line",
    d: "M187.9,31.8h-6.3c-0.3,0-0.5-0.2-0.5-0.5v-3.3c0-0.3,0.2-0.5,0.5-0.5h6.3c0.3,0,0.5,0.2,0.5,0.5v3.3C188.4,31.5,188.2,31.8,187.9,31.8z",
    style: {
      strokeDasharray: 22.363540649414062,
      strokeDashoffset: 22.363540649414062
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingPicture4);
export default __webpack_public_path__ + "static/media/WaitingPicture4.9964695862540c5720040e5adf56cfe0.svg";
export { ForwardRef as ReactComponent };